/* tslint:disable */
/* eslint-disable */
/**
 * DynamicForms.Server | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { FormContactinfoFromJSON, FormContactinfoToJSON, } from './FormContactinfo';
import { FormStepFromJSON, FormStepToJSON, } from './FormStep';
/**
 * Check if a given object implements the FormSubmit interface.
 */
export function instanceOfFormSubmit(value) {
    if (!('sessionId' in value) || value['sessionId'] === undefined)
        return false;
    if (!('documentId' in value) || value['documentId'] === undefined)
        return false;
    if (!('contactInfo' in value) || value['contactInfo'] === undefined)
        return false;
    if (!('steps' in value) || value['steps'] === undefined)
        return false;
    return true;
}
export function FormSubmitFromJSON(json) {
    return FormSubmitFromJSONTyped(json, false);
}
export function FormSubmitFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'sessionId': json['sessionId'],
        'documentId': json['documentId'],
        'contactInfo': FormContactinfoFromJSON(json['contactInfo']),
        'steps': (json['steps'].map(FormStepFromJSON)),
        'newsletterOptIn': json['newsletterOptIn'] == null ? undefined : json['newsletterOptIn'],
    };
}
export function FormSubmitToJSON(json) {
    return FormSubmitToJSONTyped(json, false);
}
export function FormSubmitToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'sessionId': value['sessionId'],
        'documentId': value['documentId'],
        'contactInfo': FormContactinfoToJSON(value['contactInfo']),
        'steps': (value['steps'].map(FormStepToJSON)),
        'newsletterOptIn': value['newsletterOptIn'],
    };
}
